// extracted by mini-css-extract-plugin
export var standaloneTable = "_f7-0";
export var standaloneTableWithBodyFill = "_f7-1";
export var withExtraHeader = "_f7-2";